import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import TradeDealForm from './TradeDealForm';
// import { initialValues  } from './initialValues-testing';
import { showTradeDealApi, updateTradeDealApi, clearEditedTradeDeal } from './tradeDealSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { PICTURE_ATTRIBUTE_NAMES } from '~/config/constants';

function TradeDealUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.shopSaga.tradeDeal);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(updateTradeDealApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showTradeDealApi({ navigate, id }));

        return () => dispatch(clearEditedTradeDeal());
    }, []);

    return (
        <TradeDealForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={PICTURE_ATTRIBUTE_NAMES}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default TradeDealUpdate;
